import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { ContentService } from '../services/content.service';
import { RootStateModel } from './root-state.model';
import { RootActions } from './root.actions';

@State<RootStateModel>({
	name: 'rootState',
	defaults: {
		content: null,
		culture: 'en-us',
		schoolList: []
	}
})
@Injectable()
export class RootState {
	constructor(private contentService: ContentService) {}

	@Selector()
	static content(state: RootStateModel) {
		return state.content;
	}

	@Selector()
	static culture(state: RootStateModel) {
		return state.culture;
	}

	@Selector()
	static formByName(state: RootStateModel) {
		return (formName: string) => {
			return state[formName].model;
		};
	}

	@Action(RootActions.GetContent)
	getContent(ctx: StateContext<RootStateModel>, action: RootActions.GetContent) {
		return this.contentService.getContent(action.schoolID, action.culture).pipe(
			tap((result) => {
				ctx.patchState({
					content: result
				});
			})
		);
	}

	@Action(RootActions.GetSchools)
	getSchools(ctx: StateContext<RootStateModel>, action: RootActions.GetSchools) {
		return this.contentService.getAllSchools(action.culture).pipe(
			tap((result) => {
				ctx.patchState({
					schoolList: result
				});
			})
		);
	}

	@Action(RootActions.SetCulture)
	setCulture(ctx: StateContext<RootStateModel>, action: RootActions.SetCulture) {
		ctx.patchState({ culture: action.culture });
	}
}
